import { render, staticRenderFns } from "./ItemIcon.vue?vue&type=template&id=3cc727c4&scoped=true&"
import script from "./ItemIcon.vue?vue&type=script&lang=js&"
export * from "./ItemIcon.vue?vue&type=script&lang=js&"
import style0 from "./ItemIcon.vue?vue&type=style&index=0&id=3cc727c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc727c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
